import secureApi from '../../utils/secureApi';
import { Banner } from '../../pages/BannerManagement/types';
import { transformExtraButtonsFromApi } from '../../pages/BannerManagement/utils/extraButtonTransforms';

interface BannerDetailsFromApi {
  _id: string;
  image: string;
  textHtml: string;
  sortNo: number;
  hasMiscProperty: boolean;
  title: string;
  type: 'plain' | 'custom';
  bannerLocation: 'home' | 'tournament';
  platform?: 'app' | 'web';
  extraButtons?: any[];
}

export async function getBannerDetails(bannerId: string): Promise<Banner> {
  const response = await secureApi.get<any>(
    `/api/v1/tournaments/admin/banners/get-by-id`,
    {
      params: { _id: bannerId },
    }
  );

  // Debug: Log the full response and data
  console.log('getBannerDetails: response:', response);

  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  const bannerData = (response as any)?.data || response;

  if (!bannerData) {
    throw new Error('Failed to fetch banner details or data is empty');
  }

  // Transform extraButtons before returning
  const transformedExtraButtons = transformExtraButtonsFromApi(bannerData.extraButtons || []);
  console.log('Transformed extraButtons:', transformedExtraButtons);

  return {
    ...bannerData,
    id: bannerData._id,
    extraButtons: transformedExtraButtons,
  } as Banner;
} 